import React from "react";
import careerBanner from "../../assets/careerBanner.jpg";

const HeroSection = ({ scrollToRef, openModal }) => {
  const handleScroll = () => {
    scrollToRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative h-[50vh] md:h-[80vh] *:font-sans flex flex-col justify-center items-center" style={{ overflow: "hidden" }}>
      <div className="absolute inset-0">
        <img src={careerBanner} className="h-full w-full object-cover" alt="Dubai Cityscape" />
        <div className="bg-black opacity-40 absolute inset-0 z-20"></div>
      </div>

      <div className="relative z-30 flex flex-col space-x-4 items-center">
        <div className="font-bold text-white text-5xl text-center mb-4">
          Take the next step in your career
        </div>
        <div className="flex justify-center">
          <button
            onClick={handleScroll}
            className="px-6 m-2 py-3 bg-white text-black font-semibold rounded-lg shadow-md hover:bg-gray-200 transition duration-300"
          >
            View Vacancies
          </button>
          <button
            onClick={openModal}
            className="px-6 m-2 py-3 bg-[#173d73] text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition duration-300"
          >
            Apply Job
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
